<template>
  <v-layout row wrap class="ch-info-component">
    <v-flex xs12 class="pt-0">
      <v-card>
        <v-card-title class="head">
          <v-layout row wrap>
            <v-flex xs12>
              <i class="fas fa-unlock-alt fa-fw"></i>
              <span class="info-name ml-2">{{ (hotel_name !== null) ? hotel_name : 'None' }}</span>
              <span class="ml-2"><b>FW: </b>{{ fw_version }}<b></b></span>
              <span class="ml-2" v-if="rootDomainOnly"><b>Model: </b>{{ fw_type }}<b></b></span>
              <span class="battery-item ml-3">
                <span :class="battery_item"></span>
                <span class="ml-1" :class="battery_item">{{ fw_battery ? `${fw_battery}%` : 'Unknown' }}</span>
              </span>
              <span class="info-id ml-2"><b>[</b> {{ (dl_serial !== null) ? dl_serial : 'None' }} <b>]</b></span>
              <button class="ml-2" @click="copyText" v-if="dl_serial">
                <i class="far fa-clone"></i>
              </button>
              <span class="box">
                <span class="name">UPDATED</span>
                <span class="time">{{ updated_at }}</span>
              </span>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text class="body ch-info-field-border">
          <v-layout row wrap class="ch-info-field-wrapper ma-0 pb-3">
            <v-flex xs6 class="pa-0" v-if="rootDomainOnly">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class="fas fa-info fa-fw"></i>
                  <span class="ml-2">SERIAL</span>
                </div>
                <div class="ch-info-field-body">
                  <v-text-field
                    class="pt-0"
                    v-model="dl_serial"
                    disabled
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class="fas fa-building fa-fw"></i>
                  <span class="ml-2">BUILDING</span>
                </div>
                <div class="ch-info-field-body">
                  <v-text-field
                    class="pt-0"
                    v-model="building_name"
                    disabled
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class="fas fa-h-square fa-fw"></i>
                  <span class="ml-2">NAME</span>
                </div>
                <div class="ch-info-field-body">
                  <v-text-field
                    class="pt-0"
                    v-model="name"
                    disabled
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class="fab fa-microsoft fa-fw"></i>
                  <span class="ml-2">FLOOR</span>
                </div>
                <div class="ch-info-field-body">
                  <v-text-field
                    class="pt-0"
                    v-model="floor_name"
                    disabled
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class="fas fa-desktop fa-fw"></i>
                  <span class="ml-2">STATUS</span>
                </div>
                <div class="ch-info-field-body">
                  <v-text-field
                    class="pt-0"
                    v-model="status"
                    disabled
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class="fas fa-exclamation-circle fa-fw"></i>
                  <span class="ml-2">TYPE</span>
                </div>
                <div class="ch-info-field-body">
                  <v-text-field
                    class="pt-0"
                    v-model="type"
                    disabled
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class="fas fa-battery-three-quarters fa-fw"></i>
                  <span class="ml-2">BATTERY UPDATED AT</span>
                </div>
                <div class="ch-info-field-body">
                  <v-text-field
                    class="pt-0"
                    v-model="fw_logged_at"
                    disabled
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class="fas fa-calendar-check fa-fw"></i>
                  <span class="ml-2">CREATED AT</span>
                </div>
                <div class="ch-info-field-body">
                  <v-text-field
                    class="pt-0"
                    v-model="created_at"
                    disabled
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class='fas fa-code-branch'></i>
                  <span class="ml-2">PINCODE VERSION</span>
                </div>
                <div class="ch-info-field-body">
                  <v-select
                    class="pt-0"
                    :items="pincodeVersionItems"
                    v-model="pincode_version"
                    content-class="detail-select"
                  ></v-select>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class='fas fa-window-minimize'></i>
                  <span class="ml-2">PINCODE LENGTH</span>
                </div>
                <div class="ch-info-field-body">
                  <v-select
                    class="pt-0"
                    :items="pincodeLengthItems"
                    v-model="pincode_length"
                    content-class="detail-select"
                  ></v-select>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class="fas fa-fire"></i>
                  <span class="ml-2" style="font-size: 11px">PINCODE DAY TYPE OFFSET</span>
                </div>
                <div class="ch-info-field-body">
                  <v-text-field
                    class="pt-0"
                    v-model="pincode_day_type_offset"
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class='fas fa-flag'></i>
                  <span class="ml-2">PINCODE ISSUABLE</span>
                </div>
                <div class="ch-info-field-body">
                  <v-select
                    class="pt-0"
                    :items="pincodeIssuableItems"
                    v-model="is_pincode_issuable"
                    content-class="detail-select"
                  ></v-select>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <div class="btn-wrapper">
            <router-link :to="{name: 'doorlocks'}">
              <button class="ch-menu-btn ch-menu-backbtn" type="button">
                <i class="fas fa-angle-left fa-fw"></i>
                LIST
              </button>
            </router-link>
            <v-spacer></v-spacer>
            <button
              class="save"
              @click="this.updateDoorlock"
            >
              <i class="fas fa-save fa-fw"></i>
              <span>SAVE</span>
            </button>
            <button
              :class="{ 'uninstall': true, active: isUninstalled }"
              @click="openDeleteDialog"
              :disabled="!isUninstalled"
            >
              <i class="fas fa-trash-alt fa-fw"></i>
              <span>UNINSTALL</span>
            </button>
            <v-dialog v-model="deleteDialog" max-width="500">
              <v-card>
                <v-card-title class="headline">{{ deleteDialogMessage }}</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="error darken-1" flat="flat" @click.native="deleteDialog = false">Cancel</v-btn>
                  <v-btn color="primary darken-1" flat="flat" @click.native="uninstalldoorlock">Uninstall</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-card-actions>
      </v-card>
    </v-flex>
    <battery v-if="rootDomainOnly && battery_render"
      :datasets="battery_datasets"
      :labels="battery_date"
      :options="battery_options"
    ></battery>
  </v-layout>
</template>

<script>
  import _ from 'lodash';
  import Battery from '@/components/customized-components/Battery';
  import doorlockFormatter from '@/components/admin/doorlocks/doorlockFormatter';
  import api from '../../../api';

  export default {
    data() {
      return {
        rootDomainOnly: false,
        id: null,
        hotel_id: null,
        hotel_name: null,
        building_id: null,
        building_name: null,
        floor_id: null,
        floor_name: null,
        name: null,
        type: null,
        status: null,
        dl_serial: null,
        deleteDialogMessage: 'Do you want to uninstall the doorlock',
        created_at: null,
        updated_at: null,
        battery_item: null,
        fw_aged: null,
        fw_version: null,
        fw_type: null,
        fw_battery: null,
        fw_logged_at: null,
        start_date: null,
        end_date: null,
        pincodeVersionItems: ['V1', 'V2'],
        pincode_version: null,
        pincodeLengthItems: [4, 6, 8],
        pincode_length: null,
        pincode_day_type_offset: null,
        pincodeIssuableItems: ['Enable', 'Disable'],
        is_pincode_issuable: null,
        // chart bind testing
        battery_render: false,
        battery_date: [],
        battery_datasets: [],
        battery_options: null,
        // NOTE: Dialog
        saveDialog: false,
        deleteDialog: false,
        isUninstalled: false,
      };
    },
    methods: {
      openDeleteDialog() {
        this.deleteDialog = true;
      },
      getDoorlockDetail() {
        const id = {
          id: this.id,
          hotel_id: this.hotel_id,
        };
        api.getDoorlockDetail(id)
        .then((result) => {
          if (result.status === 200) {
            Object.assign(this, result.data);
            // NOTE: battery image
            if (this.fw_aged) {
              this.battery_item = 'battery-item__warning';
            } else {
              if (this.fw_battery >= 80) this.battery_item = 'battery-item__good';
              if (this.fw_battery < 80 && this.fw_battery >= 30) this.battery_item = 'battery-item__normal';
              if (this.fw_battery < 30) this.battery_item = 'battery-item__replace';
            }
            if (this.is_pincode_issuable === true) this.is_pincode_issuable = 'Enable';
            else this.is_pincode_issuable = 'Disable';
            this.created_at = this.$moment(result.data.created_at).format('YYYY-MM-DD HH:mm:ss');
            this.updated_at = this.$moment(result.data.updated_at).format('YYYY-MM-DD HH:mm:ss');
            this.fw_logged_at = this.$moment(result.data.fw_logged_at).format('YYYY-MM-DD HH:mm:ss');
            this.isUninstalled = (result.data.status === 'installed' || result.data.status === 'updated');
            this.type = doorlockFormatter.type(this.type);
            this.fw_version = this.fw_version ? `v${this.fw_version}` : 'None';
            this.fw_type = this.fw_type ? doorlockFormatter.fwType(this.fw_type) : 'None';
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
          // NOTE: 삭제된 아이템
          if (err.response.status === 404) {
            console.error('Invalid page', err.response);
            this.$router.push({ name: 'doorlocks' });
          }
        });
      },
      updateDoorlock() {
        const id = {
          id: this.id,
          hotel_id: this.hotel_id,
        };
        const params = {
          name: this.name,
          pincode_version: this.pincode_version,
          pincode_length: this.pincode_length,
          pincode_day_type_offset: this.pincode_day_type_offset,
          // eslint-disable-next-line
          is_pincode_issuable: this.is_pincode_issuable === 'Enable' ? true : false,
        };
        api.updateDoorlock(id, params)
        .then((result) => {
          if (result.status === 200) {
            Object.assign(this, result.data);
            // NOTE: battery image
            if (this.fw_aged) {
              this.battery_item = 'battery-item__warning';
            } else {
              if (this.fw_battery >= 80) this.battery_item = 'battery-item__good';
              if (this.fw_battery < 80 && this.fw_battery >= 30) this.battery_item = 'battery-item__normal';
              if (this.fw_battery < 30) this.battery_item = 'battery-item__replace';
            }
            if (this.is_pincode_issuable === true) this.is_pincode_issuable = 'Enable';
            else this.is_pincode_issuable = 'Disable';
            this.created_at = this.$moment(result.data.created_at).format('YYYY-MM-DD HH:mm:ss');
            this.updated_at = this.$moment(result.data.updated_at).format('YYYY-MM-DD HH:mm:ss');
            this.fw_logged_at = this.$moment(result.data.fw_logged_at).format('YYYY-MM-DD HH:mm:ss');
            this.isUninstalled = (result.data.status === 'installed' || result.data.status === 'updated');
            this.type = doorlockFormatter.type(this.type);
            this.fw_version = this.fw_version ? `v${this.fw_version}` : 'None';
            this.fw_type = this.fw_type ? doorlockFormatter.fwType(this.fw_type) : 'None';
            this.alert.type = 'check_circle';
            this.alert.color = 'green';
            this.alert.message = 'Success Save';
            this.alertOccur();
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
          // NOTE: 삭제된 아이템
          if (err.response.status === 404) {
            console.error('Invalid page', err.response);
            this.$router.push({ name: 'doorlocks' });
          }
        });
      },
      /**
       * @description Uninstall doorlock
       */
      uninstalldoorlock() {
        const id = {
          id: this.id,
          hotel_id: this.hotel_id,
        };
        api.uninstallDoorlock(id)
          .then((result) => {
            if (result.status === 200) {
              console.log('result', result);
              this.$router.push({ name: 'doorlocks' });
            }
          })
          .catch((err) => {
            this.alert.type = 'error';
            this.alert.color = 'red';
            this.alert.message = err.response.data.message;
            this.alertOccur();
            // NOTE: 삭제된 아이템
            if (err.response.status === 404) {
              console.error('Invalid page', err.response);
              this.$router.push({ name: 'doorlocks' });
            }
          });
      },
      /**
       * @description 정보창 상단 타이틀 복사
       */
      copyText() {
        const copyTextInfo = document.createElement('input');
        const body = document.getElementsByTagName('body')[0];
        body.appendChild(copyTextInfo);
        copyTextInfo.value = this.dl_serial;
        copyTextInfo.select();
        document.execCommand('Copy');
        copyTextInfo.remove();
        this.alert.type = 'check_circle';
        this.alert.color = 'green';
        this.alert.message = 'Copied';
        this.alertOccur();
      },
      /**
       * @description 배터리 조회, 검색기간 1년(현재시간 ~ 1년 전)
       */
      getDoorlockBatteryHitory() {
        this.start_date = this.$moment().subtract(1, 'year').utc().format();
        this.end_date = this.$moment().utc().format();
        const id = {
          doorlock_id: this.id,
          hotel_id: this.hotel_id,
        };
        const query = {
          start_date: this.start_date,
          end_date: this.end_date,
        };
        api.getDoorlockBatteryHitory(id, query)
        .then((result) => {
          if (result.status === 200) {
            const resultData = _.sortBy(result.data, ['created_at']);
            this.battery_date = resultData.map(item => this.$moment(item.created_at).format('YYYY-MM-DD HH:mm:ss'));
            this.battery_datasets = [
              {
                label: 'Battery',
                backgroundColor: '#3c8dbc',
                borderColor: '#3c8dbc',
                data: resultData.map(item => (item.fw_battery === null ? 0 : item.fw_battery)),
                fill: false,
              },
            ];
            this.battery_options = {
              scales: {
                xAxes: [{
                  display: true,
                  labelString: 'Date',
                }],
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                    stepSize: 20,
                  },
                }],
              },
              maintainAspectRatio: false,
            };
            this.battery_render = true;
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
    },
    mounted() {
      this.id = this.$route.params.id;
      this.hotel_id = this.$route.params.hotel_id;
      this.getDoorlockDetail();
      if (localStorage.getItem('domain_type') === 'root') {
        this.rootDomainOnly = true;
        this.getDoorlockBatteryHitory();
      }
    },
    components: {
      Battery,
    },
  };
</script>

<style lang="scss" scoped>
.battery-item {
  display: inline-block;

  span:nth-of-type(1) {
    display: inline-block;
    width: 30px;
    height: 17px;
    vertical-align: middle;

    &.battery-item__warning {
      background-image: url('../../../assets/img/bat_gray.png');
    }
    &.battery-item__good {
      background-image: url('../../../assets/img/bat_green.png');
    }
    &.battery-item__normal {
      background-image: url('../../../assets/img/bat_orange.png');
    }
    &.battery-item__replace {
      background-image: url('../../../assets/img/bat_red.png');
    }
  }
  span:nth-of-type(2) {
    &.battery-item__warning {
      color: #666666;
    }
    &.battery-item__good {
      color: green;
    }
    &.battery-item__normal {
      color: orange;
    }
    &.battery-item__replace {
      color: red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/doorlocks/DoorlocksDetailInfo.vue